import React from 'react';
import { cn } from 'shared/lib/cn';

export type FieldProps = {
  label: string;
  htmlFor?: string;
  hint?: React.ReactNode;
  error?: string;
  required?: boolean;
  /** Short badge naming the right this control needs, e.g. "Special pricing". */
  gate?: string;
  className?: string;
  children: React.ReactNode;
};

export function Field({ label, htmlFor, hint, error, required, gate, className, children }: FieldProps) {
  return (
    <div className={cn('flex flex-col gap-1', className)}>
      <div className="flex items-baseline gap-2">
        <label htmlFor={htmlFor} className="font-body text-xs font-medium text-ink-muted">
          {label}{required ? ' *' : ''}
        </label>
        {gate && (
          <span className="rounded-[var(--radius-2)] border border-brand/30 bg-brand/10 px-1.5 font-code text-tiny uppercase text-brand-strong">
            {gate}
          </span>
        )}
      </div>
      {children}
      {error
        ? <p role="alert" className="font-body text-xs text-danger">{error}</p>
        : hint ? <p className="font-body text-xs text-ink-muted">{hint}</p> : null}
    </div>
  );
}
